import {PlayerReduxState} from "../types";

export default function canDisplayResults(state: PlayerReduxState): boolean {
  return !state.isPreview && !state.isShared && !state.isExternal;
}
